// extracted by mini-css-extract-plugin
module.exports = {"modalOverlay":"zi","modalContent":"Ai","header":"Bi","close":"Ci"};